import React from 'react'
import { useIntl } from 'react-intl'
import cn from 'classnames'

import IconCheckmark from 'client/icons/Checkmark'

import styles from '../styles.module.css'

export const RateNRFPayment = () => {
  const intl = useIntl()
  return (
    <li className={cn(styles.greenIcon, styles.listDoted)}>
      <IconCheckmark size={16} /> {intl.formatMessage({ id: 'global.pay-now' })}
    </li>
  )
}

export const RateNRFPaymentDescription = () => {
  const intl = useIntl()

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateNRFPayment />
      </ul>
      <p>{intl.formatMessage({ id: 'reservation.non-refundable-offer' })}</p>
    </>
  )
}

export const RateNRFCancelation = () => {
  const intl = useIntl()

  return (
    <li className={styles.listDoted}>{intl.formatMessage({ id: 'reservation.no-refundable' })}</li>
  )
}

export const RateNRFCancellationDescription = () => {
  const intl = useIntl()

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateNRFCancelation />
      </ul>
      <p>{intl.formatMessage({ id: 'cancelation.no-refundable' })}</p>
    </>
  )
}

const RateNRF = () => {
  return (
    <>
      <RateNRFPayment />
      <RateNRFCancelation />
    </>
  )
}

export default RateNRF
